import { NgModule } from '@angular/core';

import { EndOfLevelCongratulationComponent } from './end-of-level-congratulation.component';
import { CertificatesModule } from '../../certificates/certificates.module';
import { CommonModule } from '@angular/common';
import { TranslatePipeModule } from '../translate.pipe';

@NgModule({
    imports: [CommonModule, CertificatesModule, TranslatePipeModule],
    exports: [EndOfLevelCongratulationComponent],
    declarations: [EndOfLevelCongratulationComponent],
    providers: [],
})
export class EndOfLevelCongratulationModule { }



// WEBPACK FOOTER //
// ./ts/app/shared/end-of-level-congratulation/end-of-level-congratulation.module.ts